import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://worldcupfanplanner.com').replace(/\/$/, '');
const DEFAULT_OG_IMAGE = `${SITE_URL}/logo192.png`;

function normalizePathname(pathname) {
  if (!pathname || pathname === '/') return '/';
  return pathname.replace(/\/+$/, '') || '/';
}

const SEOHead = ({
  title,
  description,
  schema,
  noindex,
  image,
  ogType = 'website',
  canonicalPath,
}) => {
  const { pathname, search } = useLocation();
  const pathOnly = canonicalPath != null ? canonicalPath : pathname;
  const normalized = normalizePathname(pathOnly);
  const canonicalUrl = `${SITE_URL}${normalized === '/' ? '' : normalized}`;
  const ogImage = image || DEFAULT_OG_IMAGE;
  const hideFromIndex = noindex || Boolean(search && search.length > 1);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      {hideFromIndex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:site_name" content="WorldCup Fan Planner" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(Array.isArray(schema) ? schema : [schema])}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
